import { useBuzzAvailability } from '@/features/buzz/api'
import { routes } from '@/pages'
import { Spinner } from '@/ui-kit'
import { Navigate } from 'react-router-dom'

/**
 * The single decision point for "home" (`/`). Every other home entry — post-login, the
 * `/login` bounce, the logos — targets `/`, so the Calls-vs-Missions choice lives here only.
 *
 * Signed-in and anonymous sessions decide alike: `/configuration` is public, and `/calls`
 * serves anonymous visitors an onboarding with a sign-in step. The spinner holds while the
 * flag is `pending` rather than guess. Every redirect uses `replace`, so Back never lands
 * on `/` again.
 */
export const HomeRedirect = (): JSX.Element => {
  const availability = useBuzzAvailability()

  if (availability === 'pending') {
    return (
      <div className="flex flex-1 items-center justify-center">
        <Spinner />
      </div>
    )
  }

  return <Navigate to={availability === 'enabled' ? routes.calls.path : routes.missions.path} replace />
}
